import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "cp-info__line" }
const _hoisted_2 = { class: "cp-info__label" }
const _hoisted_3 = { class: "cp-info__value" }
const _hoisted_4 = {
  key: 0,
  class: "cp-info__line"
}
const _hoisted_5 = { class: "cp-info__label" }
const _hoisted_6 = { class: "cp-info__value" }
const _hoisted_7 = { class: "cp-info__label" }
const _hoisted_8 = { class: "cp-info__value" }
const _hoisted_9 = { class: "cp-info__line" }
const _hoisted_10 = { class: "cp-info__label" }
const _hoisted_11 = { class: "cp-info__value" }
const _hoisted_12 = { class: "cp-info__client" }
const _hoisted_13 = { class: "cp-info__client-head" }
const _hoisted_14 = { class: "cp-info__label" }
const _hoisted_15 = {
  key: 0,
  class: "cp-info__client-card"
}
const _hoisted_16 = {
  key: 0,
  class: "cp-info__client-address"
}
const _hoisted_17 = {
  key: 1,
  class: "cp-info__client-tags"
}
const _hoisted_18 = {
  key: 1,
  class: "cp-info__bills"
}
const _hoisted_19 = { class: "cp-info__label" }
const _hoisted_20 = { class: "cp-info__bill-index" }
const _hoisted_21 = { class: "cp-info__bill-text" }
const _hoisted_22 = { class: "cp-info__green" }
const _hoisted_23 = { class: "cp-info__green" }
const _hoisted_24 = { class: "cp-info__bill-cp" }
const _hoisted_25 = { class: "cp-info__green" }
const _hoisted_26 = { class: "cp-info__bar" }
const _hoisted_27 = {
  key: 0,
  class: "cp-info__green"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 2,
  class: "cp-info__bill-note"
}
const _hoisted_30 = {
  key: 2,
  class: "cp-info__bills"
}
const _hoisted_31 = { class: "cp-info__label" }
const _hoisted_32 = { class: "cp-info__bill-index" }
const _hoisted_33 = { class: "cp-info__bill-text" }
const _hoisted_34 = { class: "cp-info__green" }
const _hoisted_35 = { class: "cp-info__green" }
const _hoisted_36 = { class: "cp-info__bill-cp" }
const _hoisted_37 = { class: "cp-info__green" }
const _hoisted_38 = { class: "cp-info__bar" }
const _hoisted_39 = {
  key: 0,
  class: "cp-info__green"
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 2,
  class: "cp-info__bill-note"
}
const _hoisted_42 = {
  key: 1,
  class: "cp-info__empty"
}

import { formatMoney } from "@/utils/format";
import { computed, ref } from "vue";
import { i18n } from "@/i18n";

import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import ClientReattachDropdown from "@/components/main/client-block-page/dropdowns/ClientReattachDropdown.vue";
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { financesStore } from "@/store/finances";
import BillInfoModal from "./BillInfoModal.vue";
import BillInfoDialog from "@/components/multiedit/temporary/storageshared/BillInfoDialog.vue";
import { CounterpartyInfo } from "@/models/interfaces/finances/counterparty-models";
import { BillWithOneLink } from "@/models/interfaces/finances/finance-models";
import { BillType, BillLinkedTypeDescriptor } from "@/models/etc/types";
import { formatShortDate, payStatusText, barWidth } from "./bill-format";
import { useModalEscape } from "@/composables/useModalEscape";


export default /*@__PURE__*/_defineComponent({
  __name: 'CounterpartyInfoModal',
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

const t = (key: string, named?: Record<string, unknown>): string => String(named ? i18n.global.t(key, named) : i18n.global.t(key));
const emit = __emit

const info = ref<CounterpartyInfo | null>(null)
const isLoading = ref(true)
const currentId = ref(0)
const canEditClientBinding = ref(false)

const $content = ref<HTMLElement | null>(null)
const $modal = ref<InstanceType<typeof BaseModal> | null>(null)
const $reattachDropdown = ref<InstanceType<typeof AppResizableDropdown> | null>(null)
const $billInfoModal = ref<InstanceType<typeof BillInfoModal> | null>(null)
const $q = useQuasar()

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
	content: $content,
	close: () => $modal.value?.onClose()
})

const modalTitle = computed(() => {
	const name = info.value?.Name || ''
	const base = t('counterparty_full_info_title', { name })
	return info.value?.IsDraft ? t('draft_suffix', { base }) : base
})

const requisites = computed(() => {
	const m = info.value
	if (!m) return []
	return [
		{ label: t('inn'), value: m.TaxpayerNumber },
		{ label: t('kpp'), value: m.ReasonCode },
		{ label: t('personal_account2'), value: m.PersonalAccount },
		{ label: t('bank_or_settlement_account'), value: m.BankAccount },
		{ label: t('bank_name'), value: m.BankName },
		{ label: t('bik'), value: m.BankIdCode },
		{ label: t('correspondent_bank_account'), value: m.CorrespondentBankAccount },
		{ label: t('legal_address_full'), value: m.LegalAddress },
		{ label: t('legal_form'), value: m.LegalForm },
		{ label: t('comment'), value: m.Note },
	].filter(row => row.value != null && String(row.value).trim() !== '')
})

const outgoingBills = computed(() =>
	(info.value?.Bills ?? []).filter(b => b.Type === BillType.Outgoing)
)
const incomingBills = computed(() =>
	(info.value?.Bills ?? []).filter(b => b.Type === BillType.Incoming)
)

const onOpen = async (counterpartyId: number, canEditBinding = false) => {
	info.value = null
	currentId.value = counterpartyId
	canEditClientBinding.value = canEditBinding
	isLoading.value = true
	$modal.value?.onOpen()
	activateEsc()
	try {
		info.value = (await financesStore().getInfoCounterparty(counterpartyId)) ?? null
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const onReattached = async () => {
	info.value = (await financesStore().getInfoCounterparty(currentId.value)) ?? info.value
	$reattachDropdown.value?.close()
}

const openBillInfo = (bill: BillWithOneLink) => {
	// платёж (Descriptor===Payment) — открываем легаси-модалку, счёт — редизайн-модалку
	if (bill.Descriptor === BillLinkedTypeDescriptor.Payment) {
		$q.dialog({
			component: BillInfoDialog,
			componentProps: { existingBillId: bill.Id, isPayment: true }
		})
		return
	}
	$billInfoModal.value?.onOpen(bill.Id)
}

const onBillChanged = async () => {
	info.value = (await financesStore().getInfoCounterparty(currentId.value)) ?? info.value
}

const onModalClose = () => $modal.value?.onClose()

const onBaseModalClose = () => {
	deactivateEsc()
	emit('close')
}

__expose({ onOpen, onClose: onModalClose })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    title: modalTitle.value,
    loading: isLoading.value,
    width: "640px",
    height: "80vh",
    onOnClose: onBaseModalClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "$content",
        ref: $content,
        class: "cp-info"
      }, [
        (!isLoading.value && info.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('creation_date')) + ":", 1),
                _createElementVNode("span", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_unref(formatShortDate)(info.value.Date)), 1),
                  (_unref(formatShortDate)(info.value.Date))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(",")
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(info.value.CreatedInCrm ? 'created_in_crm' : 'created_in_one_c')), 1)
                ])
              ]),
              (info.value.Creator?.Name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('creator')) + ":", 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(info.value.Creator.Name), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requisites.value, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.label,
                  class: "cp-info__line"
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(row.label) + ":", 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(row.value), 1)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('one_c_instance')) + ":", 1),
                _createElementVNode("span", _hoisted_11, _toDisplayString(info.value.Instance1C || _ctx.$t('by_default')), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t(info.value.Client ? 'linked_to_client' : 'not_linked_to_client')) + ": ", 1),
                  (canEditClientBinding.value)
                    ? (_openBlock(), _createBlock(AppResizableDropdown, {
                        key: 0,
                        ref_key: "$reattachDropdown",
                        ref: $reattachDropdown,
                        position: "right",
                        resizable: "",
                        "initial-width": 360,
                        "initial-height": 420,
                        "min-width": 320,
                        "max-width": 600,
                        "min-height": 300,
                        "max-height": 700,
                        "content-z-index": 10010,
                        "close-by-click-outside": true
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(AppTooltip, {
                            text: _ctx.$t('counterparty_change_client')
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(AppIcon, {
                                class: "cp-info__client-edit",
                                name: "edit-pencil",
                                width: "14px",
                                color: "#979797",
                                "hover-color": "#499259",
                                cursor: "pointer"
                              })
                            ]),
                            _: 1
                          }, 8, ["text"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(ClientReattachDropdown, {
                            "counterparty-id": currentId.value,
                            "current-client-id": info.value.Client?.Id,
                            "show-close-icon": "",
                            onReattached: onReattached,
                            onClose: _cache[0] || (_cache[0] = ($event: any) => ($reattachDropdown.value?.close()))
                          }, null, 8, ["counterparty-id", "current-client-id"])
                        ]),
                        _: 1
                      }, 512))
                    : _createCommentVNode("", true)
                ]),
                (info.value.Client)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_router_link, {
                        class: "cp-info__client-name",
                        to: { query: { page: 'client', id: info.value.Client.Id } },
                        onClick: onModalClose
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(info.value.Client.Name), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      (info.value.Client.AddressChain?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "(" + _toDisplayString(info.value.Client.AddressChain.join(', ')) + ")", 1))
                        : _createCommentVNode("", true),
                      (info.value.Client.Tags?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.Client.Tags, (tag) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: tag.Id,
                                class: "cp-info__client-tag"
                              }, "#" + _toDisplayString(tag.Name), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (outgoingBills.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('outgoing_invoices')) + ":", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(outgoingBills.value, (bill, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: bill.Id,
                        class: "cp-info__bill"
                      }, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(i + 1) + ".", 1),
                        _createElementVNode("span", _hoisted_21, [
                          _createVNode(AppTooltip, {
                            text: _ctx.$t('bill_info_detailed')
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(AppIcon, {
                                class: "cp-info__bill-info",
                                name: "info-circle-outline",
                                width: "14px",
                                color: "#979797",
                                "hover-color": "#499259",
                                cursor: "pointer",
                                onClick: ($event: any) => (openBillInfo(bill))
                              }, null, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["text"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('bill_out_abbr')) + " ", 1),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(bill.Number || '—'), 1),
                          _createTextVNode(" [" + _toDisplayString(bill.Instance1C || _ctx.$t('by_default')) + "] ", 1),
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('date_from_prefix')) + " " + _toDisplayString(_unref(formatShortDate)(bill.Date)) + ",", 1),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(bill.Counterparty?.Name || _ctx.$t('no_counterparty')), 1),
                          _createElementVNode("span", _hoisted_25, " | " + _toDisplayString(_unref(formatMoney)(bill.TotalAmount ?? 0)) + ",", 1),
                          _createElementVNode("span", _hoisted_26, [
                            _createElementVNode("span", {
                              class: "cp-info__bar-fill",
                              style: _normalizeStyle({ width: _unref(barWidth)(bill.PayedPercent) })
                            }, null, 4)
                          ]),
                          (bill.HasPayments)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(bill.PayedPercent ?? 0) + "% (" + _toDisplayString(_unref(formatMoney)(bill.PayedAmount ?? 0)) + ")", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_unref(payStatusText)(bill.PayStatus)), 1)),
                          (bill.Note)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "[" + _toDisplayString(bill.Note) + "]", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (incomingBills.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('incoming_invoices')) + ":", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(incomingBills.value, (bill, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: bill.Id,
                        class: "cp-info__bill"
                      }, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(i + 1) + ".", 1),
                        _createElementVNode("span", _hoisted_33, [
                          _createVNode(AppTooltip, {
                            text: _ctx.$t('bill_info_detailed')
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(AppIcon, {
                                class: "cp-info__bill-info",
                                name: "info-circle-outline",
                                width: "14px",
                                color: "#979797",
                                "hover-color": "#499259",
                                cursor: "pointer",
                                onClick: ($event: any) => (openBillInfo(bill))
                              }, null, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["text"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('bill_in_abbr')) + " ", 1),
                          _createElementVNode("span", _hoisted_34, _toDisplayString(bill.Number || '—'), 1),
                          _createTextVNode(" [" + _toDisplayString(bill.Instance1C || _ctx.$t('by_default')) + "] ", 1),
                          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('date_from_prefix')) + " " + _toDisplayString(_unref(formatShortDate)(bill.Date)) + ",", 1),
                          _createElementVNode("span", _hoisted_36, _toDisplayString(bill.Counterparty?.Name || _ctx.$t('no_counterparty')), 1),
                          _createElementVNode("span", _hoisted_37, " | " + _toDisplayString(_unref(formatMoney)(bill.TotalAmount ?? 0)) + ",", 1),
                          _createElementVNode("span", _hoisted_38, [
                            _createElementVNode("span", {
                              class: "cp-info__bar-fill",
                              style: _normalizeStyle({ width: _unref(barWidth)(bill.PayedPercent) })
                            }, null, 4)
                          ]),
                          (bill.HasPayments)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(bill.PayedPercent ?? 0) + "% (" + _toDisplayString(_unref(formatMoney)(bill.PayedAmount ?? 0)) + ")", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_unref(payStatusText)(bill.PayStatus)), 1)),
                          (bill.Note)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, "[" + _toDisplayString(bill.Note) + "]", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (!isLoading.value && !info.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.$t('counterparty_info_error')), 1))
            : _createCommentVNode("", true)
      ], 512),
      _createVNode(BillInfoModal, {
        ref_key: "$billInfoModal",
        ref: $billInfoModal,
        onChanged: onBillChanged
      }, null, 512)
    ]),
    _: 1
  }, 8, ["title", "loading"]))
}
}

})